import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ACCOUNTING_EXPORTS } from "../../../../../utils/data/models";
import { reduxForm } from "redux-form";
import * as dataActions from "../../../../../utils/data/dataActions";
import AccountingExportsDataTable from "./AccountingExportsDataTable";
import { isEqual } from "lodash";
import LanguageToggle from "../../../../common/LanguageToggle/LanguageToggle";
import HistorySelector from "../historySelector/HistorySelector";
import { FormattedMessage } from "react-intl";
import { MessageBox } from "../../../../common";

class AccountingExportsFields extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.setLanguageCode = this.setLanguageCode.bind(this);
    this.setPeriodsToSend = this.setPeriodsToSend.bind(this);
    this.state = {
      translationFile: null,
      periodsToSend: [],
      chosenDate: null,
      languageCode: null,
    };
  }

  componentDidMount() {
    this.props.dataActions.clearDataList(ACCOUNTING_EXPORTS);
  }

  componentDidUpdate(prevProps, prevStates) {
    if (!isEqual(this.state.periodsToSend, prevStates.periodsToSend)) {
      this.getData();
    }
    if (
      !isEqual(this.state.languageCode, prevStates.languageCode) &&
      prevStates.languageCode != null
    ) {
      this.getData();
    }
  }

  getData() {
    let filters = this.state.periodsToSend.join(",");
    this.props.dataActions.getDataList(
      ACCOUNTING_EXPORTS,
      0,
      0,
      "",
      ["exports.exportId:desc"],
      [
        `export_configurations.type==FINANCIAL`,
        `(export_configurations.language_code==${this.state.languageCode},export_configurations.format==ACOMBA)`,
        `exports.period=in=(${filters})`,
      ]
    );
  }

  setPeriodsToSend(periods) {
    this.setState({ periodsToSend: periods });
  }

  setLanguageCode(languageCode) {
    this.setState({ languageCode: languageCode });
  }

  render() {
    return (
      <div>
        <div className="flex">
          <span className="dropdown-text-align">
            <FormattedMessage id="insurerExport.selectedPeriod" />
          </span>
          <HistorySelector
            class={"history-selector-accounting"}
            setPeriodsToSend={this.setPeriodsToSend}
          />
          <div className="toggle">
            <LanguageToggle setLanguageCode={this.setLanguageCode} />
          </div>
          <span className="message-alert">
            <MessageBox key="periodAlert" className="alert-warning">
              <FormattedMessage id="accountingExport.warning" />
            </MessageBox>
          </span>
        </div>
        <AccountingExportsDataTable />
      </div>
    );
  }
}

AccountingExportsFields.propTypes = {
  items: PropTypes.array,
  dataActions: PropTypes.object,
};

AccountingExportsFields = reduxForm({
  form: "Accounting Export",
})(AccountingExportsFields);

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

function mapStateToProps(state) {
  const data = state.data.accountingExports || {};
  return {
    items: data.items || [],
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountingExportsFields);



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/exports/accounting/AccountingExportsFields.js